import { create } from 'zustand'

const useStore = create((set) => {
    return {
        decorationTypeList: [],
        decorationPortraitList: [],
    
        setDecorationTypeList: (decorationTypeList) => set({ decorationTypeList }),
        setDecorationPortraitList: (decorationPortraitList) => set({ decorationPortraitList }),
    }
})
export default useStore